import { auth,db } from './firebaseConfig';

import { collection, doc, setDoc, deleteDoc, getDoc } from 'firebase/firestore';

const FAVORITES_SESSION_KEY = 'favorites';

const getSessionFavorites = () => {
  const sessionFavorites = sessionStorage.getItem(FAVORITES_SESSION_KEY);
  if (!sessionFavorites) return {};
  const { data, expiry } = JSON.parse(sessionFavorites);
  if (new Date().getTime() > expiry) {
    sessionStorage.removeItem(FAVORITES_SESSION_KEY);
    return {};
  }
  return data;
};

const setSessionFavorites = (favorites) => {
  const now = new Date();
  const item = {
    data: favorites,
    expiry: now.getTime() + 7 * 24 * 60 * 60 * 1000, // 7 days
  };
  sessionStorage.setItem(FAVORITES_SESSION_KEY, JSON.stringify(item));
};

export const addFavorite = async (productId, user) => {
  if (user) {
    const userFavoritesRef = doc(collection(db, 'favorites'), user.uid);
    const docSnap = await getDoc(userFavoritesRef);
    let favorites = [];
    if (docSnap.exists()) {
      favorites = docSnap.data().products || [];
    }
    if (!favorites.includes(productId)) {
      favorites.push(productId);
      await setDoc(userFavoritesRef, { products: favorites });
    }
  } else {
    const sessionFavorites = getSessionFavorites();
    sessionFavorites[productId] = true;
    setSessionFavorites(sessionFavorites);
  }
};

export const removeFavorite = async (productId, user) => {
  if (user) {
    const userFavoritesRef = doc(collection(db, 'favorites'), user.uid);
    const docSnap = await getDoc(userFavoritesRef);
    let favorites = [];
    if (docSnap.exists()) {
      favorites = docSnap.data().products || [];
    }
    favorites = favorites.filter((id) => id !== productId);
    await setDoc(userFavoritesRef, { products: favorites });
  } else {
    const sessionFavorites = getSessionFavorites();
    delete sessionFavorites[productId];
    setSessionFavorites(sessionFavorites);
  }
};

export const isFavorite = async (productId, user) => {
  if (user) {
    const userFavoritesRef = doc(collection(db, 'favorites'), user.uid);
    const docSnap = await getDoc(userFavoritesRef);
    if (docSnap.exists()) {
      const favorites = docSnap.data().products || [];
      return favorites.includes(productId);
    }
    return false;
  } else {
    const sessionFavorites = getSessionFavorites();
    return !!sessionFavorites[productId];
  }
};
